import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function OrderSkeleton() {
  return (
    <div style={{ padding: "20px", width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "70px",
        }}
      >
        <Skeleton height={30} width={200} /> {/* Page Title */}
        <Skeleton height={40} width={120} /> {/* Add More Button */}
      </div>
      <div style={{ display: "flex", gap: "10px", marginBottom: "50px" }}>
        {Array(4) // Simulating filter buttons
          .fill("")
          .map((_, index) => (
            <Skeleton key={index} height={30} width={100} />
          ))}
      </div>
      <div>
        {/* Table Header */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            padding: "10px 0",
            backgroundColor: "#f9f9f9",
          }}
        >
          <Skeleton height={20} width={"100%"} />
          <Skeleton height={20} width={"100%"} />
          <Skeleton height={20} width={"100%"} />
          <Skeleton height={20} width={"100%"} />
        </div>

        {/* Table Rows */}
        {Array(5) // Simulating 5 rows of table data
          .fill("")
          .map((_, index) => (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                padding: "10px 0",
                borderBottom: "1px solid #eaeaea",
              }}
            >
              <Skeleton height={20} width={"100%"} /> {/* Name */}
              <Skeleton height={20} width={"100%"} /> {/* Price */}
              <Skeleton height={20} width={"100%"} /> {/* Category */}
              <div style={{ display: "flex", gap: "10px" }}>
                <Skeleton height={30} width={120} />{" "}
                {/* Mark Available/Unavailable */}
                <Skeleton height={30} width={80} /> {/* Delete */}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default OrderSkeleton;
